export default (wireModel) => ({
    wireModel,

    init() {
        this.$watch('wireModel', (value) => {
            this.wireModel = (value ?? '').trim().replace(' ', '');
        });
    },
});
